/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* case 1: for treemap chart,in pre r release, its label color is always black
	* case 2: for packedBubble and pie chart, only from R11 to R13, the label color is black
	**/

	class VIDA_LabelsColorPropUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1021;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			/*
			* Cycle through all widgets and, if they are live widgets, upgrade the clipping.
			*/
			_.each(spec.widgets, model => {
				if (model && WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._labelsColorUpgrade(model);
				}
			});
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_labelsColorUpgrade(model) {
			const treeMapId = 'com.ibm.vis.rave2bundletreemap';
			const needsUpgradeVisIds = ['com.ibm.vis.rave2bundlepackedbubble','com.ibm.vis.rave2bundlepie'];
			const needsUpgradeSpec = [1008,1009];
			const originalSpecVersion = this.data && this.data.originalSpecVersion;
			if (model.visId === treeMapId || (_.contains(needsUpgradeVisIds,model.visId) && _.contains(needsUpgradeSpec,originalSpecVersion))){
				const labelsColorPropId = 'labels.color';
				const labelsColorProp = WidgetUpgradeUtils.findProperty(labelsColorPropId, model.properties);
				if (!labelsColorProp) {
					model.properties.push({
						id: labelsColorPropId,
						value: '#000000'
					});
				}
			}
		}

	}

	return new VIDA_LabelsColorPropUpgrade();
});
